import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyAllReportsRoute: InvariantJiraRoute = {
	name: 'legacy-all-reports',
	path: '/projects/:projectKey',
	query: ['selectedItem=(.*report-page.*)'],
};
